import React, { FC } from 'react'
import Image from 'next/image'
import { useConfig } from '@/root/shared-hooks'

export interface Note {
  id: number
  title: string
  body: string
  icon: string
}

const NotesFooterSection: FC<Note> = ({ title, body, icon }) => {
  const { theme } = useConfig()
  const m = body.match(/\s*(Read more|Loe edasi)\s*$/i)
  const linkText = m?.[1]
  const bodyText = linkText ? body.replace(/\s*(Read more|Loe edasi)\s*$/i, '').trim() : body

  const altText = icon ? `${title} icon` : 'Note icon'
  return (
    <div className="flex items-start gap-5">
      <div className="shrink-0">
        <Image src={`/${theme}/icons/${icon}.svg`} alt={altText} width={52} height={52} />
      </div>

      <div className="flex flex-col">
        <h3 className="text-primary-base text-lg leading-snug font-bold">{title}</h3>

        <p className="text-primary-base mt-1 text-sm leading-relaxed">{bodyText}</p>

        {linkText ? <span className="text-primary-base mt-2 text-sm font-semibold">{linkText}</span> : null}
      </div>
    </div>
  )
}

export default NotesFooterSection
